import styled from '@emotion/styled'

type PaletteCoreProps = {
  stripeWidthPercentage: number
}

export default styled.div((props: PaletteCoreProps) => ({
  label: 'PaletteCore',
  position: 'absolute',
  top: `${props.stripeWidthPercentage}%`,
  left: `${props.stripeWidthPercentage}%`,
  width: `${100 - 2 * props.stripeWidthPercentage}%`,
  height: `${100 - 2 * props.stripeWidthPercentage}%`,
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
}))
